import { Badge, Flex, Space, Tag, Tooltip, Typography } from "antd"
import dayjs from "dayjs"

import Button from "../../../../Components/Button"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import {
  adminUsersColumnIconMap,
  alertsColumnIconMap,
  dateFormat,
  statusTextMap,
  tagColorMap,
  tagMap
} from "../../../../Utils/utils"

const { Text } = Typography

const getStatusTag = (_) => {
  if (!_) return "—"
  return (
    <Tag
      color={tagMap[_?.toLowerCase()] || "default"}
      key={_}
      style={{ margin: 0 }}
      className={"simple large"}
    >
      <Space>
        <Badge
          status={tagMap[_?.toLowerCase()] || "default"}
          color={tagColorMap[_?.toLowerCase()]}
        />
        <Text>{statusTextMap[_] || _}</Text>
      </Space>
    </Tag>
  )
}

const getTimestampCell = (_) =>
  _ ? (
    <Space direction="vertical" size={4}>
      <Text>{dayjs(_).format(dateFormat)}</Text>
      <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
    </Space>
  ) : (
    "—"
  )

export const getColumns = ({ inviteRoles = [] }) => {
  const roleTextMap = inviteRoles.reduce((acc, { value, label }) => {
    acc[value] = label
    return acc
  }, {})

  return {
    status: {
      key: "status",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Status",
          sorter: true,
          icon: alertsColumnIconMap["status"],
          stateData: state,
          key: "status"
        }),
      dataIndex: "status",
      fixed: "left",
      width: 140,
      render: getStatusTag
    },
    admin_full_name: {
      key: "admin_full_name",
      title: (state) =>
        titleSortFilters({
          title: "Admin full name",
          sorter: true,
          icon: adminUsersColumnIconMap["admin_full_name"],
          stateData: state,
          key: "admin_full_name"
        }),
      dataIndex: "admin_full_name",
      sorter: true,
      width: 185,
      render: (_) => _ || "—"
    },
    email: {
      key: "email",
      title: (state) =>
        titleSortFilters({
          title: "Admin email",
          sorter: true,
          icon: adminUsersColumnIconMap["email"],
          stateData: state,
          key: "email"
        }),
      dataIndex: "email",
      sorter: true
    },
    invite_sent: {
      key: "invite_sent",
      title: (state) =>
        titleSortFilters({
          title: "Invite sent",
          sorter: true,
          icon: adminUsersColumnIconMap["invite_sent"],
          stateData: state,
          key: "invite_sent"
        }),
      dataIndex: "invite_sent",
      width: 185,
      sorter: true,
      render: getTimestampCell
    },
    last_2fa_access: {
      key: "last_2fa_access",
      title: (state) =>
        titleSortFilters({
          title: "Last 2FA access",
          sorter: true,
          icon: adminUsersColumnIconMap["last_2fa_access"],
          stateData: state,
          key: "last_2fa_access"
        }),
      dataIndex: "last_2fa_access",
      width: 185,
      sorter: true,
      render: getTimestampCell
    },
    last_activity: {
      key: "last_activity",
      title: (state) =>
        titleSortFilters({
          title: "Last activity",
          sorter: true,
          icon: adminUsersColumnIconMap["last_activity"],
          stateData: state,
          key: "last_activity"
        }),
      dataIndex: "last_activity",
      width: 185,
      sorter: true,
      render: getTimestampCell
    },
    role: {
      key: "role",
      title: (state) =>
        titleSortFilters({
          title: "Role",
          sorter: true,
          icon: adminUsersColumnIconMap["role"],
          stateData: state,
          key: "role"
        }),
      dataIndex: "role",
      width: 140,
      sorter: true,
      render: (_) => roleTextMap[_] || _ || "—"
    }
  }
}

export const getActionColumn = ({ onSelectRow }) => {
  const handleAction = (e, record, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow?.(record, type)
  }

  const renderActionSlot = (content, isVisible = true) => (
    <div style={{ width: 32, minWidth: 32, display: "flex", justifyContent: "center" }}>
      {isVisible ? content : null}
    </div>
  )

  return {
    key: "action",
    title: "Actions",
    width: 118,
    align: "center",
    render: (_, record) => (
      <Flex gap={4} justify="center">
        {renderActionSlot(
          <Tooltip title="Resend">
            <Button
              type="link"
              shape="circle"
              icon={<Icon type="arrows_repeat" />}
              onClick={(e) => handleAction(e, record, "resend")}
              className="flex center"
            />
          </Tooltip>,
          ["invite_sent", "expired"].includes(record?.status)
        )}

        {renderActionSlot(
          <Tooltip title="Settings">
            <Button
              type="link"
              shape="circle"
              icon={<Icon type="settings" />}
              onClick={(e) => handleAction(e, record, "settings")}
              className="flex center"
            />
          </Tooltip>
        )}

        {renderActionSlot(
          <Tooltip title="Delete">
            <Button
              danger
              type="link"
              shape="circle"
              icon={<Icon type="delete" />}
              onClick={(e) => handleAction(e, record, "delete")}
              className="flex center table-action-btn"
            />
          </Tooltip>
        )}
      </Flex>
    )
  }
}
